import _getIterator from 'babel-runtime/core-js/get-iterator';

import { getMaxIndex, getFileIconWithSuffix, downloadFileWithBuffer, canPreviewFile, wkPreviewFile
// getImageData
} from '@/utils';
import { downloadFileAPI } from '@/api/common';

export default {
  name: 'VuePictureViewer',
  props: {
    imgData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    background: {
      type: String,
      default: 'rgba(0,0,0,0.4)'
    },
    // 选择的索引
    selectIndex: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      // 默认不显示左右切换箭头
      leftArrowShow: false,
      rightArrowShow: false,
      // 图片容器数据
      rotateDeg: 0,
      // bigImgUrl: '',
      bigShowType: { isImage: true, icon: '' }, // 不是图片的时候 展示 icon
      bigImgName: '',
      imgLength: 0,
      imgIndex: 0,
      showTips: false,
      tipsText: '',
      bigImgConWidth: '',
      bigImgConHeight: '',
      maskContainer: {
        width: '100%',
        height: '100%',
        background: this.background,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      imgContainer: {
        width: 'auto',
        height: 'auto',
        position: 'absolute',
        top: '50%',
        left: '50%',
        'z-index': 100,
        transform: 'translate(-50%, -50%)'
      },
      bigImgStyle: {
        display: 'block',
        width: '80px',
        height: '80px',
        position: 'absolute',
        top: 50 + '%',
        left: 50 + '%',
        marginLeft: '',
        marginTop: '',
        userSelect: 'none'
      }
    };
  },

  computed: {
    title: function title() {
      var fileName = this.bigImgName.slice(0, this.bigImgName.indexOf('.'));

      return fileName + ' \uFF08' + (this.imgIndex + 1) + ' / ' + this.imgLength + '\uFF09';
    },
    currentFile: function currentFile() {
      return this.imgData[this.imgIndex];
    },
    bigImgUrl: function bigImgUrl() {
      return this.currentFile.url;
    },
    showPreviewBtn: function showPreviewBtn() {
      return canPreviewFile(this.currentFile.name);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // for (let index = 0; index < this.imgData.length; index++) {
    //   const element = this.imgData[index]
    //   if (this.isShowImage(element.name)) {
    //     this.getImageSrc(element.url, element.name, index)
    //   }
    // }

    document.getElementById('vue-picture-viewer').addEventListener('click', function (e) {
      e.stopPropagation();
    });

    this.imgLength = this.imgData.length;
    this.imgIndex = this.selectIndex;
    this.$nextTick(function () {
      // this.bigImgUrl = this.imgData[this.imgIndex].url
      _this2.bigImgName = _this2.imgData[_this2.imgIndex].name;
      _this2.getShowTypeInfo(_this2.bigImgName);

      if (_this2.imgLength > 1) {
        // 大于1的时候才会展示缩略图
        var item = _this2.$refs.thumbnailItem;
        item[_this2.imgIndex].className = 'borderActive';
      }
    });
    var self = this;
    this.$refs.bigImg.onload = function () {
      self.init();
    };

    this.maskContainer['z-index'] = getMaxIndex();
  },
  beforeDestroy: function beforeDestroy() {
    if (document.getElementById('vue-picture-viewer')) {
      document.getElementById('vue-picture-viewer').removeEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  },

  methods: {
    // getImageSrc(url, name, index) {
    //   getImageData(url).then((data) => {
    //     this.$set(this.imgData[index], 'blob', data.blob)
    //     this.$set(this.imgData[index], 'src', data.src)
    //   }).catch(() => {})
    // },

    // init
    init: function init() {
      var screenW = document.documentElement.offsetWidth || document.body.offsetWidth;
      var screenH = document.documentElement.scrollHeight || document.body.scrollHeight;
      this.$nextTick(function () {
        var ratio = [0.1, 0.2, 0.3, 0.4, 0.5, 0.7, 0.8, 0.9];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(ratio), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (this.$refs.bigImg.naturalWidth * item < screenW && this.$refs.bigImg.naturalHeight * item < screenH - 200) {
              this.bigImgConWidth = this.$refs.bigImg.naturalWidth * item;
              this.bigImgConHeight = this.$refs.bigImg.naturalHeight * item;
              this.imgContainer.width = this.bigImgConWidth + 'px';
              this.imgContainer.height = this.bigImgConHeight + 'px';
              this.bigImgStyle.width = this.bigImgConWidth + 'px';
              this.bigImgStyle.height = this.bigImgConHeight + 'px';
              this.bigImgStyle.marginLeft = -(this.bigImgConWidth / 2) + 'px';
              this.bigImgStyle.marginTop = -(this.bigImgConHeight / 2) + 'px';
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },

    // rotate init
    rotateInit: function rotateInit() {
      var screenH = document.documentElement.scrollHeight || document.body.scrollHeight;
      var ratio = [0.1, 0.2, 0.3, 0.4, 0.5, 0.7, 0.8, 0.9];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _getIterator(ratio), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (this.$refs.bigImg.naturalWidth * item < screenH - 160) {
            this.bigImgConWidth = this.$refs.bigImg.naturalWidth * item;
            this.bigImgConHeight = this.$refs.bigImg.naturalHeight * item;
            this.imgContainer.width = this.bigImgConWidth + 'px';
            this.imgContainer.height = this.bigImgConHeight + 'px';
            this.bigImgStyle.width = this.bigImgConWidth + 'px';
            this.bigImgStyle.height = this.bigImgConHeight + 'px';
            this.bigImgStyle.marginLeft = -(this.bigImgConWidth / 2) + 'px';
            this.bigImgStyle.marginTop = -(this.bigImgConHeight / 2) + 'px';
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },

    // 放大
    enlarge: function enlarge() {
      this.$nextTick(function () {
        var screenW = document.documentElement.offsetWidth || document.body.offsetWidth;
        var screenH = document.documentElement.scrollHeight || document.body.scrollHeight;
        if (this.$refs.bigImg.offsetWidth >= this.$refs.bigImg.offsetHeight && this.$refs.bigImg.offsetHeight * 2 < screenH * 2 || this.$refs.bigImg.offsetHeight >= this.$refs.bigImg.offsetWidth && this.$refs.bigImg.offsetWidth * 2 < screenW * 2) {
          this.$refs.bigImg.style.width = this.$refs.bigImg.offsetWidth * 1.3 + 'px';
          this.$refs.bigImg.style.height = this.$refs.bigImg.offsetHeight * 1.3 + 'px';
          this.$refs.bigImg.style.left = '50%';
          this.$refs.bigImg.style.top = '50%';
          this.bigImgStyle.marginLeft = -this.$refs.bigImg.offsetWidth / 2 + 'px';
          this.bigImgStyle.marginTop = -this.$refs.bigImg.offsetHeight / 2 + 'px';
        }
      });
    },

    // 缩小
    reduce: function reduce() {
      if (this.$refs.bigImg.offsetWidth > 80) {
        /**
           * clientWidth = width + padding
             offsetWidth = width + padding + border  */
        this.$refs.bigImg.style.width = this.$refs.bigImg.offsetWidth * 0.7 + 'px';
        this.$refs.bigImg.style.height = this.$refs.bigImg.offsetHeight * 0.7 + 'px';
        this.$refs.bigImg.style.left = '50%';
        this.$refs.bigImg.style.top = '50%';
        this.bigImgStyle.marginLeft = -this.$refs.bigImg.offsetWidth / 2 + 'px';
        this.bigImgStyle.marginTop = -this.$refs.bigImg.offsetHeight / 2 + 'px';
      }
    },

    // 旋转
    rotate: function rotate() {
      if (this.rotateDeg === 0) {
        this.$refs.bigImg.style.transform = 'rotate(90deg)';
        this.rotateInit();
        this.rotateDeg++;
      } else if (this.rotateDeg === 1) {
        this.$refs.bigImg.style.transform = 'rotate(180deg)';
        this.init();
        this.rotateDeg++;
      } else if (this.rotateDeg === 2) {
        this.$refs.bigImg.style.transform = 'rotate(270deg)';
        this.rotateInit();
        this.rotateDeg++;
      } else if (this.rotateDeg === 3) {
        this.$refs.bigImg.style.transform = 'rotate(360deg)';
        this.init();
        this.rotateDeg = 0;
      }
    },

    // 点击缩略图切换图片
    switchImgUrl: function switchImgUrl(num, e) {
      var item = this.$refs.thumbnailItem;
      item.forEach(function (i) {
        i.className = '';
      });
      this.imgIndex = num;
      // this.bigImgUrl = this.imgData[num].url
      this.bigImgName = this.imgData[num].name;
      this.getShowTypeInfo(this.bigImgName);
      e.currentTarget.className = 'borderActive';
      if (this.bigShowType.isImage) {
        this.init();
      }
    },

    // 切换到上一张
    handlePrev: function handlePrev() {
      if (this.imgIndex <= 0) {
        this.tips('已经是第一张了!');
        this.imgIndex = 0;
      } else {
        if (this.$refs.bigImg) {
          this.$refs.bigImg.style.transform = 'rotate(0deg)';
          this.rotateDeg = 0;
        }

        this.imgIndex--;
        // this.bigImgUrl = this.imgData[this.imgIndex].url
        this.bigImgName = this.imgData[this.imgIndex].name;
        this.getShowTypeInfo(this.bigImgName);

        var item = this.$refs.thumbnailItem;
        item.forEach(function (i) {
          i.className = '';
        });
        item[this.imgIndex].className = 'borderActive';
        if (this.bigShowType.isImage) {
          this.init();
        }
      }
    },

    // 切换到下一张
    handleNext: function handleNext() {
      if (this.imgIndex + 1 >= this.imgData.length) {
        this.tips('已经是最后一张了!');
      } else {
        if (this.$refs.bigImg) {
          this.$refs.bigImg.style.transform = 'rotate(0deg)';
          this.rotateDeg = 0;
        }

        this.imgIndex++;
        // this.bigImgUrl = this.imgData[this.imgIndex].url
        this.bigImgName = this.imgData[this.imgIndex].name;
        this.getShowTypeInfo(this.bigImgName);

        var item = this.$refs.thumbnailItem;
        item.forEach(function (i) {
          i.className = '';
        });
        item[this.imgIndex].className = 'borderActive';
        if (this.bigShowType.isImage) {
          this.init();
        }
      }
    },

    // 提示框
    tips: function tips(msg) {
      this.showTips = true;
      this.tipsText = msg;
      var _this = this;
      setTimeout(function () {
        _this.showTips = false;
      }, 10000);
    },

    // 鼠标左移
    enterLeft: function enterLeft() {
      this.leftArrowShow = true;
    },
    outLeft: function outLeft() {
      this.leftArrowShow = false;
    },

    // 鼠标右移
    enterRight: function enterRight() {
      this.rightArrowShow = true;
    },
    outRight: function outRight() {
      this.rightArrowShow = false;
    },

    // 关闭查看器
    closeViewer: function closeViewer() {
      this.$emit('close-viewer');
    },

    /** 附件逻辑 */
    downloadFile: function downloadFile() {
      var _this3 = this;

      // if (this.currentFile.src) {
      //   downloadFileWithBuffer(this.currentFile.blob, this.currentFile.name)
      // // } else {
      // console.log(this.currentFile)
      downloadFileAPI({ save_name: this.currentFile.save_name }).then(function (res) {
        var blob = new Blob([res.data], {
          type: ''
        });
        downloadFileWithBuffer(blob, _this3.currentFile.name);
      }).catch(function () {});
      // }
    },
    previewFile: function previewFile() {
      if (this.currentFile.url) {
        wkPreviewFile(this.currentFile.url, this.currentFile.name);
      }
    },
    getShowTypeInfo: function getShowTypeInfo(name) {
      var temps = name ? name.split('.') : [];
      var ext = '';
      if (temps.length > 0) {
        ext = temps[temps.length - 1];
      } else {
        ext = '';
      }

      var icon = getFileIconWithSuffix(ext);
      var isImage = ['jpg', 'png', 'gif', 'jpeg'].includes(ext.toLowerCase());
      this.bigShowType = { isImage: isImage, icon: icon };
    },
    getFileTypeIconWithSuffix: function getFileTypeIconWithSuffix(name) {
      var temps = name ? name.split('.') : [];
      var ext = '';
      if (temps.length > 0) {
        ext = temps[temps.length - 1];
      } else {
        ext = '';
      }
      return getFileIconWithSuffix(ext);
    },
    isShowImage: function isShowImage(name) {
      var temps = name ? name.split('.') : [];
      var ext = '';
      if (temps.length > 0) {
        ext = temps[temps.length - 1];
      } else {
        ext = '';
      }
      return ['jpg', 'png', 'gif', 'jpeg'].includes(ext.toLowerCase());
    },
    arrayContain: function arrayContain(array, string) {
      return array.some(function (item) {
        return item === string;
      });
    }
  }
};